import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import { RUNTIMES } from '@appblocks/platforms/PlatformUtils';
import * as micropython from './micropython';
import * as tios from './tios';
import * as zephyr from './zephyr';
import * as simulator from './simulator';


export default class DebugNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Debug Print';
        this.id = 'node_debug';
        this.icon = 'VscDebugConsole';
        this.linkedFeature = 'general';

        this.inputs = [
            {
                name: 'Print',
                portId: 'sys.debugprint',
                params: [
                    {
                        name: 'printstring',
                        description: 'The string to print',
                        dataType: TibboDataType.STRING,
                        default: '',
                    },
                ],
            },
        ];

        // this.settings = this.settings.concat([
        //     {
        //         id: 'printstring',
        //         name: 'Print String',
        //         settingType: SettingType.STRING,
        //         dataType: TibboDataType.STRING,
        //         default: '',
        //         required: true,
        //     },
        // ]);
    }

    getSettingValue(settingId: string): string {
        if (settingId === 'DISPLAY_NAME') {
            const value = super.getSettingValue(settingId);
            if (value !== '') {
                return value;
            }
            const project: ProjectConfiguration = this.project;
            const links = project.getNodeLinks(this, 'sys.debugprint');
            if (links.length > 0) {
                const link = links[0];
                const printstr = project.getNodeParameterValue(this, 'printstring');
                return `Print "${printstr}"`;
            }
        }
        return super.getSettingValue(settingId);
    }

    getName(): string {
        const project: ProjectConfiguration = this.project;
        const links = project.getNodeLinks(this, 'sys.debugprint');
        if (links.length > 0) {
            const link = links[0];
            const printstr = project.getNodeParameterValue(this, 'printstring');
            return `Print "${printstr}"`;
        }
        return super.getName();
    }

    getCodeBlocks(): CodeBlock[] {
        switch (this.project.runtime) {
            case 'micropython':
                return micropython.getCodeBlocks(this);
            case RUNTIMES.ZEPHYR:
                return zephyr.getCodeBlocks(this);
            case 'simulator':
                return simulator.getCodeBlocks(this);
            default:
                return tios.getCodeBlocks(this);
        }
    }

    getDetails(): string {
        return `##### Print
Prints a string to the console when running in debug mode.

Depending on the **Logging Mode**, this can be printed to the console, the log file, or the LCD.`;
    }
}
